import { render } from "./TheName.vue?vue&type=template&id=4552f066&scoped=true&lang=html"
import script from "./TheName.vue?vue&type=script&lang=js"
export * from "./TheName.vue?vue&type=script&lang=js"

import "./TheName.vue?vue&type=style&index=0&id=4552f066&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4552f066"]])

export default __exports__